var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"force-no-auth":""}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('activate-account',{staticClass:"mx-auto",attrs:{"id":_vm.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }